
<div class="page-container">
  <div class = "main-content">
    <div class = "main-body">

      <div class="section-container">
        <h1 class = "mat-display-medium">Our Team</h1>
      </div>

      <div class="section-container">
        <div class="grid-wrapper">
          <div class="profile-list">
            <app-profile-card
              *ngFor="let profile of profileList"
              [profile]="profile"
            ></app-profile-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
